import Container from '../containers/container';

type CoverImageProps = {
  src: string;
  alt: string;
};

export default function CoverImage({ src, alt }: CoverImageProps) {
  const bgImageStyles = {
    backgroundImage: `url(${src})`,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };

  return (
    <Container extensions="h-[300px] w-full">
      <Container extensions="relative h-full w-full info-card-image">
        <div className="absolute z-10" style={bgImageStyles}></div>
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-contain relative bg-white/20 mobile:p-2 tablet-lg:p-1 backdrop-blur-xl z-20"
        />
      </Container>
    </Container>
  );
}
